export default __webpack_public_path__ + "static/media/dots-low.14a17d65.svg";